import { ReactNode } from 'react';

import * as Styled from './multiple-choice-check.style';
import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';

import { ReactComponent as Tick } from 'lib/form/checkbox-input/tick.svg';

type Props = {
  label?: ReactNode;
  showAnswer?: boolean;
  isCorrect?: boolean;
};

const MultipleChoicePrintCheck = ({ label, showAnswer, isCorrect }: Props) => (
  <Styled.MultipleChoiceCheckboxLabel>
    {showAnswer && isCorrect ? (
      <MultipleChoiceListCorrect />
    ) : showAnswer && !isCorrect ? (
      <MultipleChoiceListIncorrect />
    ) : (
      <Styled.MultipleChoiceCheckboxDecor>
        <Tick width={16} height={16} />
      </Styled.MultipleChoiceCheckboxDecor>
    )}

    {label}
  </Styled.MultipleChoiceCheckboxLabel>
);

export default MultipleChoicePrintCheck;
